module.exports = __webpack_public_path__ + "static/warning-inline-example-7423e9c5f37a47648dc49fab9f26a165.svg";